module.exports = __webpack_public_path__ + "img/ticket-off.e7c2e3c3.svg";